import $ from 'jquery';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const LegacyScripts = () => {
  const { route } = useRouter();

  useEffect(() => {
    return () => {
      // remove all scroll and resize events from the window object
      // prevents memory leaks and thousands of errors in sentry
      $(window).off();
    };
  }, [route]);

  return null;
};

export default LegacyScripts;
